<div style="display: flex">
  <div class="workflow-column mb-0">
    <div class="title rounded-top m-0 text-capitalize p-4" matTooltip="{{ status }}">
      {{ status }}
    </div>
  </div>
</div>
<div
  *ngIf="(isLoading && !filters[2]?.value) || filters[2]?.value === status"
  class="workflow-spinner"
>
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
<div *ngIf="!isLoading" class="workflow-list-body mt-0" style="display: flex">
  <ng-container *ngIf="!filters[2]?.value || filters[2]?.value === status">
    <div
      class="workflow-column body-column mt-0 scroll"
      style="min-height: 50px"
      [ngStyle]="{ 'max-height': filteredView ? '480px' : '580px' }"
      [perfectScrollbar]="{ wheelPropagation: true, suppressScrollX: true }"
      (scroll)="onScroll($event)"
    >
      <kt-workflow-card
        *ngFor="let card of listOfWorkflows"
        [workflow]="card"
        [statusesList]="statusesList"
        [checkValues]="checkValues"
        (refreshWorkflowList)="refreshWorkflowList($event)"
      >
      </kt-workflow-card>
      <a class="navi-item load-more-label" *ngIf="!noMoreWorkflow && listOfWorkflows.length > 11">
        Loading More...
      </a>
      <a class="navi-item load-more-label" *ngIf="noMoreWorkflow && listOfWorkflows.length > 8">
        All caught up!
      </a>
      <div *ngIf="listOfWorkflows.length === 0" class="no-data-container">
        <p>No workflows.</p>
      </div>
    </div>
  </ng-container>
</div>
